import React from "react";
export default (props) => {
    const { qrCodeAsBase64 } = props;
    const [qrCodeSrc, setQrCodeSrc] = React.useState("");
    React.useEffect(() => {
        const src = `data:image/png;base64, ${qrCodeAsBase64}`;
        setQrCodeSrc(src);
    }, [qrCodeAsBase64]);
    return React.createElement("img", { src: qrCodeSrc, alt: "QR code", style: { width: "128px" } });
};
